/**
 * The Firebase Web app this browser asks for an FCM token, or `null` when the
 * build has no VAPID key.
 *
 * Its own module because `import.meta.env` does not survive ts-jest: specs mock
 * this file instead of the environment.
 *
 * Every value is PUBLIC — a Firebase web config and a VAPID public key are
 * shipped to every browser by design; what authorises a send is the push
 * service's server-side credential, which never leaves `flashka-platform`. So
 * the web app's config is committed here, exactly as the mobile apps commit
 * theirs (`flashka-app/firebase/`). It is the SAME Firebase project
 * (`flashka-59ba3`), which is what lets the push service's one FCM sender reach
 * browsers and phones alike.
 *
 * The VAPID key is the switch: without `VITE_FIREBASE_VAPID_KEY` web push is
 * unavailable — nobody is enrolled in the experiment and the settings page
 * stays hidden. Each `VITE_FIREBASE_*` overrides its default (a preview
 * pointed at another project).
 */

export interface WebPushConfig {
  firebase: {
    apiKey: string;
    projectId: string;
    messagingSenderId: string;
    appId: string;
  };
  /** Firebase console → Cloud Messaging → Web Push certificates. */
  vapidKey: string;
}

/** Firebase console → Project settings → Your apps → the Web app. */
const FLASHKA_WEB_FIREBASE: WebPushConfig['firebase'] = {
  apiKey: 'AIzaSyCL1n1ASti20Kf9PGsX4jDdMxK9Mbxi2To',
  projectId: 'flashka-59ba3',
  messagingSenderId: '166040936422',
  appId: '1:166040936422:web:7b90ea838a3a0ce6004027',
};

export function webPushConfig(): WebPushConfig | null {
  const env = import.meta.env;
  const vapidKey = env.VITE_FIREBASE_VAPID_KEY as string | undefined;
  if (!vapidKey) return null;
  return {
    firebase: {
      apiKey:
        (env.VITE_FIREBASE_API_KEY as string | undefined) || FLASHKA_WEB_FIREBASE.apiKey,
      projectId:
        (env.VITE_FIREBASE_PROJECT_ID as string | undefined) ||
        FLASHKA_WEB_FIREBASE.projectId,
      messagingSenderId:
        (env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined) ||
        FLASHKA_WEB_FIREBASE.messagingSenderId,
      appId:
        (env.VITE_FIREBASE_APP_ID as string | undefined) || FLASHKA_WEB_FIREBASE.appId,
    },
    vapidKey,
  };
}
